import { createStyles, Theme, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        validImage: {
            width: '100%',
            minHeight: 218.25,
            height: '100%',
            position: 'relative',
            zIndex: 10,
        },
        invalidImage: {
            width: '100%',
            height: 218.25,
            position: 'relative',
            zIndex: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: theme.palette.background.default,
        },
        photoContainer: {
            width: '100%',
            position: 'relative',
            '&:hover $photoOverlay > button:first-child': {
                display: 'block',
            },
        },
    })
);
